import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder';

import { SANITY_PROJECT_ID, SANITY_DATASET } from 'configs';

const sanityClient = createClient({
  projectId: SANITY_PROJECT_ID,
  dataset: SANITY_DATASET,
  apiVersion: '2024-09-16',
  useCdn: true,
});

const builder = imageUrlBuilder(sanityClient);

const urlFor = (source: string): ImageUrlBuilder => {
  return builder.image(source);
};

export { urlFor, sanityClient };
